import { usePublishCreateEstimateBlockers } from "pages/CreateOrder/hooks/usePublishCreateEstimateBlockers";

/** CLE-3043 — renders nothing; mounted inside each estimate page's FormProvider. */
export function CreateEstimateBlockersPublisher(): null {
  usePublishCreateEstimateBlockers();
  return null;
}
